import React from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import BoutonEtape from 'components/form/boutonsEtape/BoutonEtape';
import { LIEN_BOUTON_AVIS_AJOUT_ARME_MANQUANTE } from 'constants/liensBoutonJeDonneMonAvis.constants';
import BoutonJeDonneMonAvis from 'components/BoutonJeDonneMonAvis/BoutonJeDonneMonAvis';
import { Container, Row, Col } from '@si-armes/dsfr-react';
import RoutesRatelier from '../../../../ratelier/routes';
import { getPath } from '../../../../../../utils/router';

const FinaliserArmeManquanteEtape3 = () => {
    const hookForm = useForm({
        mode: 'onSubmit',
    });
    const history = useHistory();
    const { handleSubmit } = hookForm;

    const onSubmit = () => {
        history.push(getPath(RoutesRatelier));
    };

    return (
        <Container fluid={false}>
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col col={12}>
                        <h2>Finalisation de la procédure</h2>
                    </Col>
                </Row>
                <Row>
                    <Col col={12}>
                        <p>
                            L&apos;arme a été ajoutée avec succès sur votre râtelier numérique. Vous
                            pouvez donner votre avis sur la procédure d&apos;ajout d&apos;arme en
                            cliquant sur le bouton ci-dessous ou cliquer sur le bouton
                            &quot;Terminer&quot; pour revenir sur votre râtelier numérique.
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col col={12}>
                        <BoutonJeDonneMonAvis
                            lienBouttonJeDonneMonAvis={LIEN_BOUTON_AVIS_AJOUT_ARME_MANQUANTE}
                        />
                    </Col>
                </Row>
                <BoutonEtape
                    labelBtnSuivant="Terminer"
                    nameBtnSuivant="terminerArmeManquante"
                    btnSuivantDisabled={false}
                    btnPrecedentVisible={false}
                />
            </form>
        </Container>
    );
};

FinaliserArmeManquanteEtape3.propTypes = {};

export default connect()(FinaliserArmeManquanteEtape3);
